import { FormattedMessage } from 'react-intl';

type DisplayCommentProps = { comment: string };

const DisplayComment = (props: DisplayCommentProps) => {
  const { comment } = props;

  return (
    <div className="text-small text-grey-dark">
      <FormattedMessage id="generic.note" />
      {': '}
      <span>{comment}</span>
    </div>
  );
};

export default DisplayComment;
